import { flexRender, type Row } from '@tanstack/react-table';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { TableRowContext } from '@/features/ChangeOrder/Summary/Table/TableRowContext';

type TableRowProps = {
  row: Row<unknown>;
  onRowClick?: (row: Record<string, any>) => void;
};

export function TableRow({ row, onRowClick }: TableRowProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedRow, setEditedRow] = useState<Record<string, any>>({});

  return (
    <TableRowContext.Provider value={{ editedRow, setEditedRow, isEditing, setIsEditing }}>
      <tr className={twMerge(['hover:bg-green-50', row.getIsSelected() && 'bg-gray-50'])}>
        {row.getVisibleCells().map((cell) => (
          <td
            key={cell.id}
            className={twMerge('px-4 py-4', isEditing && 'px-4 py-3.5')}
            style={{
              width: cell.column.columnDef.size,
              maxWidth: cell.column.columnDef.maxSize || 'auto',
              minWidth: cell.column.columnDef.minSize,
            }}
            onClick={() =>
              onRowClick &&
              cell.column.id !== 'rowSelect' &&
              cell.column.id !== 'actions' &&
              onRowClick(row.original as Record<string, any>)
            }
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        ))}
      </tr>
    </TableRowContext.Provider>
  );
}
